import { initialIntelState } from './index';
import { kdTabColumnVisibility, TabColumnOrder } from './visibilityDefaults';

const IntelReducer = (state, action) => {
  switch (action.type) {
    case 'SET_TAB_COL_VISIBILITY': {
      const tab = action.payload.currentTab;
      const updatedColVisibility = { ...state.columnVisibility };
      updatedColVisibility[action.payload.colSet][tab] =
        action.payload.newModel;
      return { ...state, columnVisibility: updatedColVisibility };
    }
    case 'SET_TAB_COL_ORDER': {
      const tab = action.payload.currentTab;
      const thisTab = state.columnOrder[tab];
      if (thisTab) {
        const existing = thisTab?.find(
          (x) => x.field === action.payload.colReorder.field
        );
        const newOrder = thisTab?.filter(
          (x) => x.field !== action.payload.colReorder.field
        );
        if (existing) {
          action.payload.colReorder.oldIndex = existing.oldIndex;
        }
        if (
          action.payload.colReorder.oldIndex !==
          action.payload.colReorder.targetIndex
        ) {
          newOrder.push(action.payload.colReorder);
        }
        state.columnOrder[tab] = newOrder;
        return { ...state, columnOrder: state.columnOrder };
      } else {
        state.columnOrder[tab] = [action.payload.colReorder];
        return { ...state, columnOrder: state.columnOrder };
      }
    }
    case 'SET_ENEMY':
      return {
        ...state,
        enemyKd: action.payload,
      };
    case 'SET_ENEMY_DATA':
      return {
        ...state,
        enemyData: action.payload,
      };
    case 'SET_ENEMY_PLAN':
      return {
        ...state,
        enemyPlan: action.payload,
      };
    case 'SET_OWN_DATA':
      return {
        ...state,
        ownData: action.payload,
      };
    case 'SET_OWN_PLAN':
      return {
        ...state,
        ownPlan: action.payload,
      };
    case 'SET_CURRENT_TICK':
      return {
        ...state,
        currentTick: action.payload,
      };
    case 'RESET_COLS':
      return {
        ...state,
        columnVisibility: kdTabColumnVisibility,
        columnOrder: TabColumnOrder,
      };
    case 'SET_SERVER':
      return {
        ...state,
        server: action.payload,
      };
    case 'SET_LOADING':
      return {
        ...state,
        loading: action.payload,
      };
    case 'SET_KINGDOM_NEWS':
      return {
        ...state,
        kingdomNews: action.payload,
      };
    case 'SET_PROVINCE_NEWS':
      return {
        ...state,
        provinceNews: action.payload,
      };
    case 'SET_RACES':
      if (!action.payload) return state;
      switch (action.server) {
        case 1:
          return {
            ...state,
            racesWol: action.payload,
          };
        case 2:
          return {
            ...state,
            racesGen: action.payload,
          };
        default:
          return state;
      }
    case 'RESET_INTEL_STATE': {
      return { ...initialIntelState };
    }
    default:
      console.log('no reducer action found');
      return state;
  }
};

export default IntelReducer;
